import { useState } from 'react';
import { BsShare } from 'react-icons/bs';

type ShareButtonProps = {
    title: string;
};

const ShareButton: React.FC<ShareButtonProps> = ({ title }) => {
    const [copied, setCopied] = useState(false);

    const share = async () => {
        const url = window.location.href;

        if (navigator.share) {
            try {
                await navigator.share({ title, url });
                return;
            } catch (error) {
                if (error instanceof DOMException && error.name === 'AbortError') return;
            }
        }

        if (!navigator.clipboard) return;
        await navigator.clipboard.writeText(url);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
    };

    return (
        <button
            type="button"
            onClick={share}
            className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-white transition hover:opacity-90"
        >
            <BsShare aria-hidden="true" />
            {copied ? 'Lien copié' : 'Partager'}
        </button>
    );
};

export default ShareButton;
